import React, { type AnchorHTMLAttributes } from 'react';

interface Props {
    children: React.ReactNode;
}
type ExternalLinkProps = Props & AnchorHTMLAttributes<HTMLAnchorElement>;

export function ExternalLink(props: ExternalLinkProps) {
    return <a {...props} target="_blank" rel="noreferrer" />;
}
